import { defineStore } from "pinia";
import { ref } from "vue";
import { storage } from "/@/cool/utils";
import { getCurrentLang } from "/@/utils/currentLang";
import { normalizeLang } from "/@/utils/normalizeLang";

const ZHCN = "zh-CN";
const EN = "en";

export const useLangStore = defineStore("lang", function () {
	// 基本信息
	const info = ref<String>(getCurrentLang() || ZHCN);
	const revision = ref(0);
	const list = ref<String[]>([ZHCN, EN]);
	// 设置基本信息
	function set(data: string) {
		const next = normalizeLang(data);
		if (info.value !== next) {
			revision.value += 1;
		}
		info.value = next;
		storage.set("lang", info.value);
		// i18next-browser-languagedetector 直接读取原生 localStorage，不能用 store 的 JSON 编码格式
		if (typeof localStorage !== "undefined") {
			localStorage.setItem("i18nextLng", next);
		}
	}

	function get() {
		return info.value;
	}

	function isZh() {
		return info.value === ZHCN;
	}

	function switchLang() {
		if (info.value == ZHCN) {
			set(EN);
		} else {
			set(ZHCN);
		}
	}

	return {
		info,
		revision,
		set,
		list,
		isZh,
		get,
		switchLang
	};
});
